// extracted by mini-css-extract-plugin
export var skipAnimation = "_1e-0";